import React, { useState, useRef, MouseEventHandler, useEffect } from "react";
import IconButton from "./IconButton";
import Button from "./Button";
import SVG from "src/utils/SVG";
import cn from "classnames";
import styled, { css } from "styled-components";
import { useAppSelector } from "src/store/actions/action";
import { isEmpty } from "lodash";

interface ISearchInputProps {
  id: string;
  type: string;
  defaultValue?: string;
  placeholder?: string | undefined;
  variant?: string;
  className?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  onKeyPress?: React.KeyboardEventHandler<HTMLInputElement>;
  deleteSearchContentFunc?: any;
}

const SearchInput = (props: ISearchInputProps) => {
  // reducer 선언 값

  const { id, type, placeholder } = props;
  const [inputValue, setInputValue] = useState(props.defaultValue || "");
  const [displayButton, setDisplayButton] = useState<boolean>();

  useEffect(() => {
    setInputValue(props.defaultValue!);
  }, [props]);

  useEffect(() => {
    if (!isEmpty(inputValue)) {
      setDisplayButton(true);
    } else {
      setDisplayButton(false);
    }
  }, [inputValue]);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleDelete = (e: React.MouseEvent<HTMLButtonElement>) => {
    setInputValue("");
    if (props.deleteSearchContentFunc) {
      props.deleteSearchContentFunc();
    }
  };

  return (
    <SearchInputSet className={cn({ hasInputValue: inputValue })}>
      <input
        id={id}
        type={type}
        onChange={(e) => {
          handleChange(e);
          if (props.onChange) props.onChange!(e);
        }}
        // value를 사용해서 에러가 나는데...
        value={inputValue}
        placeholder={placeholder}
        onKeyPress={props.onKeyPress}
      />
      <IconButton btnName="검색" className="search-icon" onClick={props.onClick}>
        <SVG name="search" width={24} height={24} viewBox="0 0 24 24"></SVG>
      </IconButton>
      {/* 인풋에 value가 있을 때 노출 */}
      {displayButton && (
        <IconButton btnName="검색 키워드 삭제" className="search-del" onClick={handleDelete}>
          <SVG name="searchDel" width={24} height={24} viewBox="0 0 24 24"></SVG>
        </IconButton>
      )}
    </SearchInputSet>
  );
};

// SearchInput
const SearchInputSet = styled.div`
  position: relative;
  input {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 0 84px 0 20px;
    border: none;
    border-radius: 20px;
    background: ${({ theme }) => theme.color.bgPrimary};
    color: ${({ theme }) => theme.color.secondary};
    font-size: 16px;
    font-family: "Roboto";
    font-weight: 700;
    &::placeholder {
      font-weight: 400;
    }
  }
  .search-icon {
    position: absolute;
    right: 15px;
    top: 50%;
    margin-top: -12px;
  }
  .search-del {
    /* display: none; */
    position: absolute;
    right: 54px;
    top: 50%;
    margin-top: -12px;
  }
`;

export default SearchInput;
